import React from "react";
import { Route, Routes } from "react-router-dom";
import PatientDashboard from "./components/DataVisualization/DataVisualizationPage";
import PrivateRoute from "./components/Common/PrivateRoute";
import Home from "./components/Home/Home";
import Login from "./components/Login/Login";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import AssessmentHistoryPage from "./components/PatientDashboard/PatientDashboardPage";
import Signup from "./components/Signup/Signup";
import AssessmentForm from "./components/AssessmentForm/AssessmentForm";
import AssessmentPage from "./components/AssessmentForm/AssessmentPage";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <nav>
          <Navbar />
        </nav>
      </header>
      <main className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/patient-dashboard"
            element={
              <PrivateRoute>
                <PatientDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/assessment-history"
            element={
              <PrivateRoute>
                <AssessmentHistoryPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/assessment-form"
            element={
              <PrivateRoute>
                <AssessmentForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/assessment-page"
            element={
              <PrivateRoute>
                <AssessmentPage />
              </PrivateRoute>
            }
          />
          <Route path="/Login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
